import React from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";

const CancellationReturnRefundPolicy = () => {
  ChangeTitle("Cancellation, Return & Refund Policy");

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Cancellation, return & refund policy
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="">
            <h1 className="mb-[2rem] legal-title-y">Cancellation</h1>
            <p className="mb-[2rem] w-full legal-para">
              How will I get a refund for the cancelled orders, and how long
              will this process take?
            </p>
            <div className="mb-[2rem]">
              <p className="legal-text-fs legal-text-b">
                Cancellation before Shipment
              </p>
              <p className="pl-[2rem] legal-para">
                If you cancel before shipment, we process the refund within
                24-48 business hours of receiving the cancellation request.
              </p>
            </div>
            <div className="mb-[2rem]">
              <p className="legal-text-fs legal-text-b">
                Cancellation after Shipment
              </p>
              <p className="pl-[2rem] legal-para">
                In the case of cancellation, once the shipment has already been
                dispatched or if it is being returned, we process the refund
                once the products have been received and verified at our
                warehouse. The refund process may take 10-15 business days.
              </p>
            </div>
            <h1 className="mb-[2rem] legal-title-y">
              Returns, Replacements, and Refunds
            </h1>
            <div className="mb-[2rem]">
              <p className="mb-[2rem] legal-text-fs legal-text-b">
                How do I return a product/service purchased in the store?
              </p>
              <ul className="pl-[3.5rem] legal-ul-disc-g">
                <li className="legal-ul-disc-g-li">
                  Login to gcclawhelp/bookstore
                </li>
                <li className="legal-ul-disc-g-li">
                  Go to Profile {">"} Click on Orders
                </li>
                <li className="legal-ul-disc-g-li">Click on Cancel Order</li>
                <li className="legal-ul-disc-g-li">
                  Check your email for confirmation of successful cancellation.
                </li>
              </ul>
            </div>
            <div className="mb-[2rem]">
              <p className="legal-text-fs legal-text-b">
                Can I partially return my order?
              </p>
              <p className="legal-para">
                Yes, you can return an item if you have ordered multiple items.
                You can easily initiate a return/replacement/refund for any
                individual item.
              </p>
            </div>
            <p className="mb-[2rem] legal-text-fs legal-text-b">
              When can I return the products/services purchased at the GCC Tax
              Help Store?
            </p>
            <div className="mb-[2rem]">
              <p className="mb-[2rem] legal-para">
                The timelines for returning/exchanging are mentioned below as
                Product - Timelines
              </p>
              <ul className="pl-[3.5rem] legal-ul-disc-g">
                <li className="legal-ul-disc-g-li">
                  Books - Within seven days from the date of delivery.
                </li>
                <li className="legal-ul-disc-g-li">
                  Virtual Books/Journals - Within seven days from the date of
                  activation
                </li>
                <li className="legal-ul-disc-g-li">
                  DVDs / Dongles / Pen drives (including Offline Research
                  Platform on Laws, etc.) - Within seven days from the key's
                  delivery date.
                </li>
                <li className="legal-ul-disc-g-li">
                  Research, Practice, etc. - Within seven days from the
                  activation date.
                </li>
                <li className="legal-ul-disc-g-li">
                  e-Newsletters - Within seven days from the date of activation
                </li>
                <li className="legal-ul-disc-g-li">
                  Online Classes - Any time before the commencement of the class
                </li>
                <li className="legal-ul-disc-g-li">
                  Courses - Within seven days from the first class scheduled
                  after the enrolment.
                </li>
              </ul>
            </div>
            <div className="mb-[2rem]">
              <p className="mb-[2rem] legal-text-fs legal-text-b">
                How will I get refunded for the returned orders, and how long
                will this process take?
              </p>
              <p className="legal-para">
                In case of a return/replacement/refund, we process the refund
                once the products have been received and verified at our
                location.
              </p>
              <p className="mb-[2rem] legal-para">
                This process may take 15 working days’ time. The refund shall be
                initiated through the method(s) as follows i.e., Payment Mode -
                Refund Mode
              </p>
              <ul className="pl-[3.5rem] legal-ul-disc-g">
                <li className="legal-ul-disc-g-li">
                  Credit card/Debit card/e-Wallets - NEFT to Bank Account
                </li>
                <li className="legal-ul-disc-g-li">
                  Bank Account through net banking - NEFT to Bank Account
                </li>
                <li className="legal-ul-disc-g-li">
                  Cash on Delivery - NEFT to Bank Account
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancellationReturnRefundPolicy;
